import React from "react";
import Carousel from '../Carousel/Carousel';
import './movilidad.css';
import { carouselMovilidad } from '../../json/movilidadbanner';
import YoutubeCarousel from '../../json/YoutubeCarousel';

const Movilidad1 = ({titulo}) => {
    return(
            <div className="container container-mh"> 
            <div className="title">
            <p></p>  
            <h1>Movilidad Responsable</h1>
            <hr class="hr-gob"></hr>
            <h3>Jerarquía de la Movilidad</h3>
            <br></br>
            <div className='secretaria_logo1' >
            <div className='secretaria_logo_img1' style={{backgroundImage: 'url("assets/imgs/SEMOT.gif")'}}> 
            </div>
            </div>
            <br></br>
            <p></p>
            <Carousel bannerData={carouselMovilidad} search={false} name="banner-principal1" />
            <div className='btn_organigrama'>
            <a href= 'https://docs.google.com/forms/d/e/1FAIpQLSeqSPEFBNOeNYjceBPbwVcVZPOSzoSv8SpOEDhEmGHYZP6T5g/viewform'><button type="button" className="btn btn-primary">Encuesta</button></a>
            <h5>¿Qué tanto sabes de Movilidad?</h5>
            </div>
            </div>
            
            <div className="title">
            <h3>Sección de videos de Movilidad Responsable</h3>
            <p></p>
            <YoutubeCarousel/>
              <p></p>
            </div>
            <div className='row'>
  <div className="col-md-4 col-12">
    <div className="video-frame">
      <iframe
        width="255"
        height="453"
        src="https://www.youtube-nocookie.com/embed/S-sg5eLoxUY"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      </div>
      <h6 className="video-title"> 3.- Respeta áreas exclusivas </h6>
  </div>
  <div className="col-md-4 col-12">
    <div className="video-frame">
      <iframe
        width="255"
        height="453"
        src="https://www.youtube-nocookie.com/embed/6eCgrKMEank"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
    <h6 className="video-title"> 7.- Peatón mantente alerta </h6>
  </div>
  <div className="col-md-4 col-12">
    <div className="video-frame">
      <iframe
        width="255"
        height="453"
        src="https://www.youtube-nocookie.com/embed/j-naBkd9d_8"
        title="YouTube video player"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
    <h5 className="video-title"> 17.- Respeta perros guía </h5>
  </div>
  <p></p>
</div>
</div>
        )
}
export default Movilidad1
